import getCollection from './getCollection'
import { doc, setDoc } from 'firebase/firestore/lite'

const updateSlotTimetable = async (id, slotTimetable, value) => {
  slotTimetable.set(value)
  return setDoc(doc(getCollection(), id), slotTimetable, { merge: true })
}

export default updateSlotTimetable
